import { createSelector } from 'reselect';
import { get } from 'lodash';

const getContent = state => state.hotContent;
export const getHotContentSelector = createSelector(
  [getContent, (_, s) => s], (hotContent, section) => get(hotContent, `[${section}].data`)
);
